import * as React from 'react';
import PropTypes from 'prop-types';
import { ThemeProvider, createTheme } from '@mui/material/styles';

import { inputsCustomizations } from './customizations/inputs';
import { dataDisplayCustomizations } from './customizations/dataDisplay';
import { feedbackCustomizations } from './customizations/feedback';
import { navigationCustomizations } from './customizations/navigation';
import { surfacesCustomizations } from './customizations/surfaces';
import { colorSchemes, shadows, shape } from './themePrimitives';
import '@fontsource/poppins';

function AppTheme({ children, disableCustomTheme, themeComponents }) {
    const theme = React.useMemo(() => {
        return disableCustomTheme
            ? {}
            : createTheme({
                Typography: {
                    fontFamily: 'Poppins, Arial, sans-serif',
                    h1: {
                        fontFamily: 'Poppins, Arial, sans-serif',
                        fontSize: '3rem',
                        fontWeight: 700,
                    },
                    h2: {
                        fontFamily: 'Poppins, Arial, sans-serif',
                        fontSize: '2.5rem',
                        color: '#0b062b',
                        fontWeight: 600,
                    },
                    body1: {
                        fontFamily: 'Poppins, Arial, sans-serif',
                        fontSize: '16px',
                        color: '#0C072C',
                        lineHeight: 'normal',
                        fontWeight: 'normal'
                    },
                    button: {
                        fontFamily: 'Poppins, Arial, sans-serif',
                        textTransform: 'uppercase',
                        fontWeight: 500,
                    },
                },
                // For more details about CSS variables configuration, see https://mui.com/material-ui/customization/css-theme-variables/configuration/
                cssVariables: {
                    colorSchemeSelector: 'data-mui-color-scheme',
                    cssVarPrefix: 'template',
                },
                colorSchemes, // Recently added in v6 for building light & dark mode app, see https://mui.com/material-ui/customization/palette/#color-schemes

                shadows,
                shape,
                // cssVars: {
                //     '--template-bg-image': 'url(../assets/images/healthcare/bgimg.jpg)', // Define a CSS variable for background
                // },
                palette: {

                    primary: {
                        main: '#4F46E5', // This is the main color for primary theme
                        light: '#63a4ff', // Light variant of primary color
                        lighter: '#EDF0FF',
                        dark: '#004ba0', // Dark variant of primary color
                        contrastText: '#fff', // Text color when using the primary color
                    },
                    secondary: {
                        main: '#dc004e', // Define secondary color as well
                    },
                    background: {
                        // default: 'var(--template-bg-image)', // Reference the CSS variable
                        paper: '#4C58B2',
                        modal: '#FFF'
                    },
                    buttonVar: {
                        reset: '#858585',
                        resetText: '#333333',
                        cancel: '#FF6760'
                    },
                },

                components: {
                    ...inputsCustomizations,
                    ...dataDisplayCustomizations,
                    ...feedbackCustomizations,
                    ...navigationCustomizations,
                    ...surfacesCustomizations,
                    ...themeComponents,

                },

            });
    }, [disableCustomTheme, themeComponents]);
    if (disableCustomTheme) {
        return <React.Fragment>{children}</React.Fragment>;
    }
    return (
        <ThemeProvider theme={theme} disableTransitionOnChange>
            {children}
        </ThemeProvider>
    );
}

AppTheme.propTypes = {
    children: PropTypes.node,
    /**
     * This is for the docs site. You can ignore it or remove it.
     */
    disableCustomTheme: PropTypes.bool,
    themeComponents: PropTypes.object,
};

export default AppTheme;
